import api from "./api";

export const searchCatalogue = async (query, { page = 1, pageSize = 5, signal } = {}) => {
  const response = await api.get("catalogue/search/", {
    params: { q: query, page, page_size: pageSize, include: "evaluations,devoirs,audios,chapitres" },
    signal,
  });
  return response.data;
};
